export const BILLS_SET_BILLS = 'BILLS_SET_BILLS';
